module.exports = __webpack_public_path__ + "img/identidade-verso-sample.a10ac64f.png";